<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 공정 이상 통보서 NO. -->
							<th class="col-1">{{ getMessage_('QWCC001433') }}</th>
							<td class="position-relative">
								{{ detailForm.powBttmInfmNo }}
							</td>
							<!-- 진행상태 -->
							<th class="col-1">{{ getMessage_('QWCC001094') }}</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.pgsStCd"
									:options="pgsStList"
									:onChange="val => setDetailForm(val, 'pgsStCd')"
									:placeholder="getMessage_('QWCC001094')"
									disabled
								/>
							</td>
							<!-- 발생일자 -->
							<th class="col-1">{{ getMessage_('QWCC001032') }}</th>
							<td>
								<el-date-picker
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									:value="detailForm.insnDd?.replaceAll('-', '')"
									@input="val => setDetailForm(val, 'insnDd')"
									readonly
								/>
							</td>
							<!-- 라인 -->
							<th class="col-1">{{ getMessage_('QWCC001137') }}</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.powLnCd"
									:options="powLnList"
									:onChange="val => setDetailForm(val, 'powLnCd')"
									:placeholder="getMessage_('QWCC001137')"
									disabled
								/>
							</td>
							<!-- 차수 -->
							<th class="col-1">{{ getMessage_('QWCC001379') }}</th>
							<td>
								<el-input :value="detailForm.ipnNos" readonly />
							</td>
							<!-- 부적합 항목 수 -->
							<th class="col-1">{{ getMessage_('QWCC001435') }}</th>
							<td>
								{{ detailForm.incsPrvsIct }}
							</td>
						</tr>
						<tr>
							<!-- 대책 회신 -->
							<th>{{ getMessage_('QWCC001436') }}</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.mdvRplCd"
									:options="mdvRplList"
									:onChange="val => setDetailForm(val, 'mdvRplCd')"
									:placeholder="getMessage_('QWCC001436')"
									:disabled="setDisabled"
								/>
							</td>
							<!-- 불필요 사유 -->
							<th>{{ getMessage_('QWCC001795') }}</th>
							<td colspan="5">
								<el-input
									maxlength="33"
									:placeholder="getMessage_('QWCC001448')"
									:show-word-limit="true"
									:value="detailForm.rplSbc"
									@input="val => setDetailForm(val, 'rplSbc')"
									:readonly="setDisabled"
								/>
							</td>
							<!-- 회신 요구일 -->
							<th>{{ getMessage_('QWCC001437') }}</th>
							<td>
								<el-date-picker
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									:value="detailForm.rplRqDd?.replaceAll('-', '')"
									@input="val => setDetailForm(val, 'rplRqDd')"
									:readonly="detailForm.mdvRplCd === 'RPL20' || setDisabled"
								/>
							</td>
							<th colspan="2"></th>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/ptin/PowTourStts/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		setDisabled() {
			return !(this.isPqyStaff && ((this.detailForm.pgsStCd == 20 && this.getCheckWriterSelf_) || this.detailForm.pgsStCd < 20));
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setDetailForm(value, key) {
			try {
				this.setState_({ key: 'isSaved', value: true });
				if (key === 'mdvRplCd' && value === 'RPL20') {
					this.setDetailForm_({ key: 'rplRqDd', value: '' });
				}
				if (key === 'rplRqDd' && value && value < this.$moment().format('YYYYMMDD')) {
					value = this.$moment().format('YYYYMMDD');
					// 회신 요구일은 과거 날짜가 될 수 없습니다
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001621'), [this.getMessage_('QWCC001437')]));
				}
				this.setDetailForm_({ key, value });
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		}
	}
};
</script>
